module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/mv-b1a69021f0d1b7de29013d94a40d1ea8.png";